import React from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { LeaderboardsHubBody } from '@/app/games/leaderboards-hub';
import { AppText } from '@/components/ui/AppText';
import { Screen } from '@/components/ui/Screen';

/**
 * Top-level Leaderboard tab: the same bracket / predictions / fantasy board
 * switcher as the Games hub, but with a tab title header (no back button) since
 * it is a root destination next to Leagues.
 */
export default function LeaderboardTab() {
  const { t } = useTranslation();
  return (
    <Screen>
      <View className="px-4 pb-3 pt-2">
        <AppText variant="title">{t('tabs.leaderboard')}</AppText>
      </View>
      <LeaderboardsHubBody />
    </Screen>
  );
}
